import React, { useEffect, useState } from 'react';
import { ReactComponent as ArrowDiagonal } from 'assets/icons/arrow-diagonal.svg';
import DeliverySettingsModal from './delivery-settings-modal';
import { CoKitchenPolygons } from 'models/cokitchen.model';
import { getGeneralSurgeSnapshot, getPolygonSurge } from 'utils/firebase';
import useDashboardContext from 'contexts/dashboard.context';

const DeliverySettings = ({ defaultPolygon }: { defaultPolygon: CoKitchenPolygons }) => {
  const [showModal, setShowModal] = useState(false);
  const [delivery, setDelivery] = useState(false);
  const { activeCokitchen } = useDashboardContext();

  useEffect(() => {
    if (defaultPolygon?.id) {
      if (defaultPolygon.id === 'ALL') {
        getGeneralSurgeSnapshot(activeCokitchen.id, (doc: any) => {
          const { delivery: newDelivery } = doc;
          setDelivery(newDelivery);
        });
      } else
        getPolygonSurge(defaultPolygon.id, (doc: any) => {
          const { delivery: newDelivery } = doc;
          setDelivery(newDelivery);
        });
    }
  }, [defaultPolygon]);
  return (
    <div className='flex justify-start items-center font-medium'>
      <p className='text-current'>
        Delivery:
        <span className={`${delivery ? '' : 'text-red-5'}`}>{delivery ? 'ON' : 'OFF'}</span>
      </p>
      <div className='gap-4 cursor-pointe' onClick={() => setShowModal(true)}>
        <ArrowDiagonal />
      </div>
      {showModal && (
        <DeliverySettingsModal
          defaultPolygon={defaultPolygon}
          show
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default DeliverySettings;
